import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetUserAccountByIdQuery } from '~/redux/api/userApiSlice';
import Favorites from '~/modules/activities/pages/Favorites/index';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';
import { useBreakpoint } from '~/hooks';

const SharedProperties = ({ showNotes = false }: { showNotes?: boolean }) => {
  const { id } = useParams();
  const { data, isLoading } = useGetUserAccountByIdQuery(id);
  const [totalListing, setTotalListing] = useState(0);
  const userName = data ? data.full_name : '';
  const { t } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();

  return (
    <div className="layout-boundary py-3x md:py-4x">
      <div className="layout-boundary__inner flex flex-col gap-3x md:gap-4x w-full">
        <div className="w-full flex flex-col gap-3x md:gap-4x flex-1">
          <div className="mx-2x md:mx-0 bg-[#E8F2F966] flex gap-2x md:gap-3x p-2x md:p-3x rounded-[12px] border border-b-[3px] border-t-0 border-blue_light_2">
            <div className="flex items-center justify-center gap-2x w-[56px] h-[56px] md:w-[72px] md:h-[72px] rounded-full text-white bg-[linear-gradient(145.84deg,_#75B4DB_7.53%,_#024168_83.66%)]">
              <Icon name="user" size="40" />
            </div>
            <div className="flex flex-col gap-x">
              {isLoading ? (
                <Skeleton
                  width={mobileScreen ? '220px' : '320px'}
                  height={24}
                  borderRadius={14}
                />
              ) : (
                <p className="text-title-3 md:text-title-1 !font-[400]">
                  {t('favorite')} {userName}
                </p>
              )}
              {isLoading ? (
                <Skeleton width="100px" height={24} borderRadius={14} />
              ) : (
                <p className="text-gray__dark_1 text-caption-1 ms:text-body-2">
                  {totalListing} {t('ads')}
                </p>
              )}
            </div>
          </div>
          <Favorites
            isSheared
            showNotes={showNotes}
            setTotalListing={setTotalListing}
          />
        </div>
      </div>
    </div>
  );
};

export default SharedProperties;
